import Headers from "../../config/headers";
import ApiCalls from "../../config/apiCalls";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import { keyMapsAction } from "../../helpers/storeKeys";
import Utility from "../../helpers/utility";
import { isDesktop } from "../../config/apiEndpoints";

export default {
  namespaced: true,
  state: {
    welcomeOffers: [],
    selectedOfferIndex: -1,
    selectedOfferTnc: [],
    autoApplyDefaultPersonalisedOfferRef: 0,
    paymentOffers: ["80 Cashback", "70 Cashback", "20 Cashback"],
    isOpenOfferAppliedModal: false,
    showTncModal: false,
    offerFailedMsg: "",
    isLoading: true,
    popupSource: "",
  },
  getters: {},
  mutations: {
    triggerAutoApplyDefaultPersonalisedOfferRef(state, payload) {
      state.autoApplyDefaultPersonalisedOfferRef = Utility.randomnumber(100000000, 999999999);
    },
    updateWelcomeOffer(state, payload) {
      state.welcomeOffers = payload;
    },
    updateSelectedOfferIndex(state, payload) {
      state.selectedOfferIndex = payload;
    },
    updateSelectedOfferTnc(state, payload) {
      state.selectedOfferTnc = payload;
    },
    updateOfferApplyModalKey(state, payload) {
      state.isOpenOfferAppliedModal = payload;
    },
    updateShowTncModal(state, payload) {
      state.showTncModal = payload;
    },
    updateOfferFailedMsg(state, payload) {
      state.offerFailedMsg = payload;
    },
    updateIsLoading(state, payload) {
      state.isLoading = payload;
    },
    updatePopupSource(state, payload) {
      state.popupSource = payload;
    },
  },
  actions: {
    welcomeOfferApi({ commit, state }, payload) {
      const extraHeader = Utility.getNxgMiddlewareHeaders();
      const default_source_name = !isDesktop ? "PWA18" : "NewDesktop";
      commit("updateIsLoading", true);
      const userInfo = LocalStorageFunc.getUserData();
      ApiCalls.STORE_OFFERS_API({
        headers: {
          ...Headers(),
          source: userInfo?.headers?.source || default_source_name,
          ...extraHeader,
          channelId: Headers().api_key,
        },
        payload: LocalStorageFunc.storeId(),
      })
        .then(function (response) {
          if(response?.data){
            const newResponse = Utility.translateNewResponseToOldResponseCoupon(response?.data);
            if(newResponse.coupons && newResponse.coupons?.length){
              let _ = Utility.jsonParser(_siteProps_.props.autoApplyOffer);
              if (_?.type == "WELCOME" && _?.code) {
                newResponse.coupons.push({
                  couponCode: _.code,
                  promoCode: _.code,
                  noshowInPersonalize: true,
                });
              }
              commit("updateWelcomeOffer", newResponse.coupons);
              if (LocalStorageFunc.getCouponCode()?.code !== undefined) {
                let currentCoupneCodeIndex =
                  newResponse.coupons.findIndex(
                    (i) => i.promoCode == LocalStorageFunc.getCouponCode().code
                  );
                commit("updateSelectedOfferIndex", currentCoupneCodeIndex);
              }
              commit("updateOfferApplyModalKey", true);
              
            }
          }
        })
        .catch(function (error) {
          commit("updateWelcomeOffer", {});
        })
        .finally(function() {
          commit("updateIsLoading", false);
        });
    },
    applyOfferApi({ commit, dispatch, rootState }, payload) {
      ApiCalls.APPLY_WELCOME_OFFER_API({
        headers: Headers(),
        payload: {
          promoCode: payload.promoCode,
          cartId: LocalStorageFunc.cartId(),
          isBinOffer:
            payload.paymentOptions?.filter((_) => _.paymentId == "CC")?.length >
            0,
        },
      })
        .then(function (response) {
          if (response.data.status == "SUCCESS") {
            commit("updateOfferFailedMsg", "");
            if (rootState.Config.copyOfferCodeOnApply) {
              navigator?.clipboard?.writeText(payload.promoCode);
            }
            payload.showOfferAppliedModal();
            LocalStorageFunc.updateCouponCode(payload.promoCode);
            if (payload.paymentOptions) {
              let _ = payload.paymentOptions.filter((_) => _.paymentId == "CC");
              if (_.length > 0) {
                let appliedOffer = {
                  status: "",
                  label: _[0].label,
                  name: _[0].paymentId,
                  index: 1,
                  paymentId: _[0].paymentId,
                  paymentMode: _[0].paymentId,
                };
                LocalStorageFunc.updatePaymentOfferpaymentId(appliedOffer);
              }
            }
            dispatch(keyMapsAction.OFFER_TNC_API, payload, { root: true });
          } else {
            response.data.errors[0].displayMsg &&
              commit(
                "updateOfferFailedMsg",
                response.data.errors[0]?.displayMsg || ""
              );
          }
        })
        .catch(function (error) {
          /* payload.showOfferAppliedModal(); */
          commit("updateOfferFailedMsg", "");
        });
    },
    removeOfferApi({ commit, dispatch, rootState }, payload) {
      ApiCalls.REMOVE_WELCOME_OFFER_API({
        headers: Headers(),
        payload: {
          promoCode: payload.promoCode,
          cartId: LocalStorageFunc.cartId(),
          isBinOffer:
            payload.paymentOptions?.filter((_) => _.paymentId == "CC")?.length >
            0,
        },
      })
        .then(function (response) {
          if (response.data.status == "SUCCESS") {
          } else {
          }
        })
        .catch(function (error) {});
    },
    offerTncApi({ commit }, payload) {
      const extraHeader = Utility.getNxgMiddlewareHeaders();
      const userInfo = LocalStorageFunc.getUserData();
      ApiCalls.OFFER_TNC_API({
        headers: {
          ...Headers(),
          source: userInfo?.headers?.source || "",
          ...extraHeader,
          channelId: Headers().api_key,
        },
        payload
      })
        .then(function (response) {
          if (response?.data?.tnc) {
            commit("updateSelectedOfferTnc", response.data.tnc);
          } else {
            commit("updateSelectedOfferTnc", []);
          }
        })
        .catch(function (error) {
          commit("updateSelectedOfferTnc", []);
        });
    },
  },
};
